import React, { useEffect, useState } from 'react';
import { message, Spin } from 'antd';
import { fetchApi, fetchDownloadApi } from '../../../services/api';
import constants from '../../../constants/constants';

const ViewDocument = () => {
	const documentValue = JSON.parse(sessionStorage.getItem("documentValue"));
	const [documentUrl, setDocumentUrl] = useState("");
	const [loader, setLoader] = useState(false);
	const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
	const isAndroid = /Android/i.test(navigator.userAgent);
	const isMobile = isIOS || isAndroid;
	useEffect(() => {
		viewDocument();
		return () => {
			sessionStorage.removeItem("documentValue");
		};
	}, []);

	const viewDocument = () => {
		setLoader(true);

		let payload = {};

		switch (documentValue?.file_type) {
			case "result-pdf":
				payload.client_id = documentValue?.client_id;
				break;

			case "notes-pdf":
				payload = documentValue?.notes_payload;
				break;

			case "payment-pdf":
				payload = documentValue?.payment_payload;
				break;

			case "screening-pdf":
				payload = {
					answers: documentValue?.answers,
				};
				if (documentValue?.client_id) {
					payload.client_id = documentValue?.client_id;
				} else if (documentValue?.enquiry_id) {
					payload.enquiry_id = documentValue?.enquiry_id;
				}
				break;
			case "section-pdf":
				payload.doc_name = documentValue?.doc_name;
				payload.flag = 1;
				break;

			default:
				payload.doc_id = documentValue?.doc_id;
				payload.doc_name = documentValue?.doc_name;
		}
		const fetchPromise =
			documentValue?.file_type === "screening-pdf"
				? fetchDownloadApi(`/screening-form-pdf`, "post", payload, null, true)
				: documentValue?.file_type === "section-pdf" ? fetchDownloadApi(`/view-document`, "post", payload, constants.ApiUrl, false) : fetchApi(`/view-document`, "post", payload);

		fetchPromise.then((res) => {
			setLoader(false);

			if (documentValue?.file_type === "screening-pdf" && res instanceof Blob || documentValue?.file_type === "section-pdf" && res instanceof Blob) {
				// BINARY PDF
				const blob = new Blob([res], { type: "application/pdf" });
				const fileURL = URL.createObjectURL(blob);
				setDocumentUrl(fileURL);
			}
			else
				if (res?.data) {
					// For base64 or URL response
					setDocumentUrl(res?.data);
				} else {
					message.error(res?.message || "Failed to load document");
				}
		}).catch((err) => {
			console.error("Document load error:", err);
			setLoader(false);
			message.error("Failed to load document");
		});
	};

	const isPdfType = [
		"pdf",
		"result-pdf",
		"notes-pdf",
		"payment-pdf",
		"screening-pdf",
		"section-pdf"
	].includes(documentValue?.file_type);

	const renderDocument = () => {
		if (!documentValue) return <div></div>;

		if (isPdfType) {
			if (isMobile) {
				return (
					<div style={{ textAlign: "center", paddingTop: "40px" }}>
						<a
							href={documentUrl}
							target="_blank"
							rel="noopener noreferrer"
							style={{
								padding: "12px 20px",
								backgroundColor: "#1677ff",
								color: "#fff",
								borderRadius: "6px",
								textDecoration: "none"
							}}
						>
							Open PDF
						</a>
					</div>
				);
			}
			return (
				<div className="iframe-container">
					<iframe
						loading="lazy"
						src={documentUrl}
						title="Document Viewer"
						onError={() => message.error("Failed to load PDF in viewer")}
					/>
				</div>
			);
		} else {
			return (
				<div className="min-h-screen grid place-content-center place-items-center">
					<img
						src={documentUrl}
						alt="Report"
						style={{ maxWidth: '100%', maxHeight: '100%' }}
					/>
				</div>
			);
		}
	};


	return (
		<Spin spinning={loader} size="large">
			{renderDocument()}
		</Spin>
	);
};
export default ViewDocument;